import { useMemo, useCallback } from "react";

import { IMessageId, ILocalizable } from "infrastructure/localization";

import { useLocalizer, isMessageId } from "./useLocalizer";

type LocalizedObject<T> = {
  [P in keyof T]: string;
};

type LocalizableObject<T> = {
  [P in keyof T]: IMessageId | ILocalizable;
};

export function useLocalizedValues<T extends LocalizableObject<T>>(factory: () => T): LocalizedObject<T> {
  const localize = useLocalizer();
  const factoryCall = useCallback(factory, []);

  return useMemo(() => {
    const messages = factoryCall();
    const result = {} as LocalizedObject<T>;

    for (const prop in messages) {
      const value: IMessageId | ILocalizable = messages[prop];
      if (isMessageId(value)) {
        result[prop] = localize(value);
      } else {
        result[prop] = localize(value.messageId, value.tokens);
      }
    }
    return result;
  }, [factoryCall, localize]);
}
